Position context for requests scoped to an applicant list.
